module.exports = __webpack_public_path__ + "img/favicon.2da7ae8fff90220abb0db988e85d85ea.png";